__turbopack_context__.v({
  "cardLink": "AIServicesSection-module-scss-module__RC7KFa__cardLink",
  "cardWrapper": "AIServicesSection-module-scss-module__RC7KFa__cardWrapper",
  "container": "AIServicesSection-module-scss-module__RC7KFa__container",
  "fade-in-up": "AIServicesSection-module-scss-module__RC7KFa__fade-in-up",
  "introColumn": "AIServicesSection-module-scss-module__RC7KFa__introColumn",
  "visible": "AIServicesSection-module-scss-module__RC7KFa__visible",
});
